import styled from '@emotion/styled';

// Container

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

// Layout

export const HEADER_HEIGHT = '64px';

interface LayoutProps {
  sidebarWidth?: string | number;
}

export const Layout = styled.div<LayoutProps>`
  display: grid;
  grid-template-columns: ${props => (props.sidebarWidth ? `${props.sidebarWidth} 1fr` : '1fr')};
  min-height: 100vh;
`;

// Header

export const Header = styled.div`
  max-height: ${HEADER_HEIGHT};
  position: sticky;
  top: 0;
  z-index: 5;
`;

// Centered

export const Centered = styled.div`
  min-width: 0px;
  min-height: 90vh;
  overflow: auto;
`;

// Sidebar

export const Sidebar = styled.div`
  display: flex;
  max-height: 100vh;
  flex-direction: column;
  position: sticky;
  overflow: hidden;
  top: 0;
`;

// Content

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
`;

export const MobileHeader = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 5;
`;

export const MobileLayout = styled.div`
  padding-top: ${HEADER_HEIGHT};
  padding-bottom: ${HEADER_HEIGHT};
  position: relative;
`;

export const MobileBottomMenu = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 5;
`;
